import * as types from "../ActionType";

const initState = {
    subCat: [],
    loadingSubCat: true,
    subCatById: [],
    dayss: [],
    social: [],
    loadingSocial: true
}

const SubCategoryReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_ALL_SUBCATEGORY:
            return { ...state, subCat: action.payload, loadingSubCat: false }
        case types.ADD_SUBCATEGORY:
            return { ...state, loadingSubCat: true }
        case types.DELETE_SUBCATEGORY:
            return { ...state, loadingSubCat: true }
        case types.EDIT_SUBCATEGORY:
            return { ...state, loadingSubCat: true }
        case types.GET_SUBCATEGORY_BY_ID:
            return { ...state, subCatById: action.payload }
        case types.GET_ALL_DAYS:
            return { ...state, dayss: action.payload }
        default:
            return state;
    }
};

export default SubCategoryReducer;
